import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/blocks/root/app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EnumKeyValueListPipe } from '../pips/enumList.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { CustomPaginatorIntl } from '../services/custom-paginator-intl.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PageNotFoundComponent } from '../components/page-not-found/page-not-found/page-not-found.component';
import { FooterComponent } from '../components/footer/footer.component';
import { DatePerZonePipe } from '../pips/date.pipe';
import { MAT_DATE_LOCALE, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FileUploaderComponent } from '../components/file-uploader/file-uploader.component';
// import { AgmCoreModule } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NumbersOnlyDirective } from '../directive/numbers-only.directive';
import { AlphanumericUppercaseDirective } from '../directive/alphanumeric-uppercase.directive';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { OtpInputComponent } from '../components/otp-input/otp-input.component';
import { ConfirmDeletingComponent } from '../components/confirm-deleting/confirm-deleting.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TimezoneInterceptor } from '../interceptors/time-zone-Interceptor';
import { TranslateModule } from '@ngx-translate/core';
import { PdfPreviewDialogComponent } from '../components/pdf-preview-dialog/pdf-preview-dialog.component';
import { FileSaverModule } from 'ngx-filesaver';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { SignatureControlComponent } from '../components/signature-control/signature-control.component';
import { TruncatePipe } from '../pips/truncate.pipe';
import { UnitPricePipe } from '../pips/unit-price.pipe';
import { OpportunityCardComponent } from '../components/opportunity-card/opportunity-card.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { SimpleFooterComponent } from '../components/footer/simple-footer/simple-footer.component';
import { AppTabsComponent } from '../components/tabs/tabs.component';
import { AppTabComponent } from '../components/tabs/tab.component';
import { CancelReasonDialogComponent } from '../components/cancel-reason-dialog/cancel-reason-dialog.component';
import { AddDpmDialogComponent } from '../components/add-dpm-dialog/add-dpm-dialog.component';
import { KycHighRiskDialogComponent } from '../components/kyc-high-risk-dialog/kyc-high-risk-dialog.component';
import { KYCDraftComponent } from 'src/app/features/kyc/kyc-draft/kyc-draft.component';
@NgModule({
  declarations: [
    EnumKeyValueListPipe,
    PageNotFoundComponent,
    FooterComponent,
    DatePerZonePipe,
    FileUploaderComponent,
    NumbersOnlyDirective,
    AlphanumericUppercaseDirective,
    OtpInputComponent,
    ConfirmDeletingComponent,
    PdfPreviewDialogComponent,
    ConfirmDialogComponent,
    SignatureControlComponent,
    OpportunityCardComponent,
    TruncatePipe,
    UnitPricePipe,
    SimpleFooterComponent,
    AppTabsComponent,
    AppTabComponent,
    CancelReasonDialogComponent,
    AddDpmDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatOptionModule,
    MatRadioModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    //  GoogleMapsModule,
    NgSelectModule,
    MatAutocompleteModule,
    TranslateModule,
    //  NgxMatDatetimePickerModule,
    //  NgxMatTimepickerModule,
    //  NgxMatNativeDateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    FooterComponent,
    DatePerZonePipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatSelectModule,
    MatCheckboxModule,
    EnumKeyValueListPipe,
    MatExpansionModule,
    MatPaginatorModule,
    MatTabsModule,
    MatProgressBarModule,
    MatOptionModule,
    MatRadioModule,
    MatStepperModule,
    FileUploaderComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatSidenavModule,
    NumbersOnlyDirective,
    AlphanumericUppercaseDirective,
    // AgmCoreModule,
    // GoogleMapsModule,
    NgSelectModule,
    MatAutocompleteModule,
    OtpInputComponent,
    ConfirmDeletingComponent,
    TranslateModule,
    PdfPreviewDialogComponent,
    FileSaverModule,
    SignatureControlComponent,
    TruncatePipe,
    UnitPricePipe,
    OpportunityCardComponent,
    SimpleFooterComponent,
    AppTabsComponent,
    AppTabComponent,
    CancelReasonDialogComponent,
    AddDpmDialogComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: HTTP_INTERCEPTORS, useClass: TimezoneInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    DatePerZonePipe
  ],

})
export class SharedModule { }
